<!--
  A full-width text content block with huge, hero text.
-->
<template>
  <div class="my-20 text-black">
    <h2 :class="brandService.getName() === Brand.HIS ? 'font-gotham-bold text-brand-secondary' : 'font-extrabold text-gray-900'" class="text-3xl sm:text-5xl sm:leading-none sm:tracking-tight lg:text-6xl">{{ title }}</h2>
    <p v-if="subtitle" :class="brandService.getName() === Brand.HIS ? 'font-gotham-medium ' : 'font-light text-gray-500 '" class="sm:mt-2 max-w-2xl text-xl ">{{ subtitle }}</p>
  </div>
</template>

<script setup lang="ts">
import { defineProps } from 'vue';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { Brand } from '../../services/integration/enums';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

defineProps<{
  title: string,
  subtitle?: string
}>();
</script>
